import { createFileRoute } from '@tanstack/react-router';

import { BlockedListLayout } from '../features/supply/blockedList/BlockedListLayout';

export const Route = createFileRoute('/supply/blocked-list')({
  component: BlockedListLayout,
});
